"use client";

import { useLocale, useTranslations } from "next-intl";
import Image from "next/image";
import styles from "./page.module.css"; // Ensure this imports the combined CSS file
import { Figtree } from "next/font/google";
import { redirect } from "@/i18n/navigation";
import { countrySlugMap } from "@/lib/localizedRoutes/localizedCountries";

const figtree = Figtree({
  weight: ["400", "500", "600", "700", "800"],
  subsets: ["latin"],
});

export default function ErrorPage() {
  const locale = useLocale();
  const t = useTranslations("Error");

  return (
    <main className={`${figtree.className} ${styles.errorMain}`}>
      <div className={styles.errorWrapper}>
        <div className={styles.errorImageContainer}>
          <Image
            src="/server_error.webp"
            alt="Server Error"
            width={1540}
            height={1024}
            className={styles.errorImage}
            priority
            unoptimized
          />
        </div>

        <h1 className={styles.errorTitle}>{t("errorTitle")}</h1>
        <h2 className={styles.errorSubTitle}>{t("errorSubtitle")}</h2>

        <div className={styles.errorButtonsWrapper}>
          <button
            className={styles.errorPrimaryButton}
            onClick={(e) => {
              e.preventDefault();
              window.location.reload();
            }}
          >
            {t("tryAgain")}
          </button>

          <button
            onClick={() => {
              let href = "/";

              if (typeof window !== "undefined") {
                const preferredCountry =
                  sessionStorage.getItem("preferredCountry");
                if (preferredCountry && countrySlugMap[preferredCountry]) {
                  const slug = countrySlugMap[preferredCountry][locale];
                  href = `/${slug}`;
                }
              }
              redirect({ href, locale });
            }}
            className={styles.errorSecondaryButton}
          >
            {t("goHome")}
          </button>
        </div>
      </div>
    </main>
  );
}
